"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledEmptyStateBox = exports.StyledOverlay = exports.NewtonFooterMain = exports.NewtonMain = exports.NewtonBody = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NewtonBody = _styledComponents["default"].div.withConfig({
  displayName: "Elements__NewtonBody",
  componentId: "sc-1034fi-0"
})(["position:relative;padding:0 16px;z-index:1;margin-top:0;background:", ";height:calc(100vh - 56px - 76px);overflow-y:scroll;", " ", " .portfolio__tos--container,.portfolio__policy--container{margin:unset;padding:0;}.portfolio__tos--title,.portfolio__policy--title{text-align:left;}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.isTabletPortrait && (0, _styledComponents.css)(["padding:108px 0 56px 248px;"]);
}, function (props) {
  return props.isDesktopSmall && (0, _styledComponents.css)(["padding:108px 0 56px 288px;"]);
});

exports.NewtonBody = NewtonBody;

var NewtonMain = _styledComponents["default"].div.withConfig({
  displayName: "Elements__NewtonMain",
  componentId: "sc-1034fi-1"
})(["height:100%;opacity:1;transition:opacity 300ms ease;"]);

exports.NewtonMain = NewtonMain;

var NewtonFooterMain = _styledComponents["default"].div.withConfig({
  displayName: "Elements__NewtonFooterMain",
  componentId: "sc-1034fi-2"
})(["position:fixed;z-index:2;bottom:0;left:0;width:100%;"]);

exports.NewtonFooterMain = NewtonFooterMain;

var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledOverlay",
  componentId: "sc-1034fi-3"
})(["height:100vh;width:100vw;background:", ";position:fixed;top:0;left:0;"], function (props) {
  return props.theme.portfolioBackground1;
});

exports.StyledOverlay = StyledOverlay;
var StyledEmptyStateBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledEmptyStateBox",
  componentId: "sc-1034fi-4"
})(["position:absolute;top:50%;left:50%;margin-top:-54px;margin-left:-190px;"]);
exports.StyledEmptyStateBox = StyledEmptyStateBox;